import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
// import {Card,CardBody} from '../../../../../../../../../hoc/Card';
// import BootstrapRow from '../../../../../../../../../hoc/BootstrapRow';
// import BootstrapColumn from '../../../../../../../../../hoc/BootstrapColumn';
// import Datetime from 'react-datetime';
import moment from 'moment';
// import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../../../../../../Utils/UserFunctions';
import {MonthDaysList} from '../defaultList';
import FormInputFields from "../../../../../../FormInputFields";
import 'moment-timezone';
class OnCustomOption extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dt: moment(),
      setDt: moment(),
      isReminderPopup:false,
      isReminderSelected:false
    }
  }
  render() {
    const  {
      attr,
      reminderJson,
      actionChangeHandler,
      dueDiff
    } = this.props;
    let remindPeriodArr =[];
    remindPeriodArr =['minute(s)', 'hour(s)', 'day(s)', 'week(s)', 'month(s)', 'year(s)'];
    const remindValidation = [1,1,1,7,28,356];
    let timeValue = reminderJson.remind_time;

    let val = reminderJson.remind_date;// moment(reminderJson.remind_date).format(getDateFormat());
    // console.log('val',reminderJson);
    timeValue = (timeValue!=='')?moment(timeValue, 'HH:mm', true).format('hh:mm A'):'';
    return (
      <Wrp>
        <div className="row mb-2">
          <div className="col-12">
            <label >Remind Date</label>
            <FormInputFields  
              type='DatePick'
              value={val}
              attributes={{
                ...attr.fieldAttributes,
                putDateFormat:'YYYY-MM-DD',
                getDateFormat:'YYYY-MM-DD',
              }}
              changeHandler={(val)=>this.props.actionChangeHandler({},'remind_date',val)}
               />
          </div>
        </div>
        <div className="d-flex w-100 mb-3">
          
					<div className="input-group">
            <label className="">&nbsp;</label>
						  <div className="input-group-prepend">
							  <select className="form-control" value={reminderJson.remind_on} onChange={e=>this.reminderOnChangeHandler(e,e.target.value)}>
                  {/* {(onDayValidation.indexOf(reminderJson.remind_period)!==-1)? */}
                    {/* <option value={0}>On</option> */}
                  {/* :''} */}
                  {(MonthDaysList().map((day,dayIndex)=>{
                    if(Number(day.value)<=Number(dueDiff))
                    return(
                      <option 
                        value={day.value} 
                        key={dayIndex}>{day.label}</option>
                    )
                  }))}
                </select>
						  </div>
              <select className="form-control" value={reminderJson.remind_period} onChange={e=>actionChangeHandler(e,'remind_period',e.target.value)}>
                {(remindPeriodArr.map((period,periodIndex)=>{
                  if(((Number(reminderJson.remind_on)===0 && periodIndex>1) || Number(reminderJson.remind_on)>0) && (dueDiff>=remindValidation[periodIndex])){
                    if(dueDiff>=remindValidation[periodIndex])
                    return(
                      <option 
                          value={periodIndex} 
                          key={periodIndex} >{period.charAt(0).toUpperCase() + period.slice(1)}</option>
                    )
                  }
                }))}
              </select>
					</div>	 
					<div className="input-group ml-2">
            <label className={"w-100"}>{(Number(reminderJson.remind_on)===0)?'of due date':'before of due'}</label>
						<div className="input-group-prepend">
							<span className="input-group-text"> at </span>
						</div>
            <FormInputFields  
              type='TimePick'
              value={timeValue}
              attributes={{
                ...attr.fieldAttributes,
                autoComplete:'off',
                putDateFormat:'HH:mm',
                // getDateFormat:'HH:mm',
                }}
              changeHandler={(val)=>this.props.actionChangeHandler({},'remind_time',val)}
               />
					</div>
				</div>
      </Wrp>    
    );
  }
  
  reminderOnChangeHandler = (e,value)=>{
    const {actionChangeHandler} = this.props;
    if(Number(value)===0){
      actionChangeHandler(e,'remind_period',2)
    }
    actionChangeHandler(e,'remind_on',value);
  }
  
}


OnCustomOption.defaultProps = {
}

export default OnCustomOption;
